import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { crearCurso } from '../services/cursosService'
import CursoForm from '../components/cursos/CursoForm'

export default function NuevoCursoPage() {
  const { organizacion } = useAuth()
  const navigate = useNavigate()

  async function handleSubmit(values) {
    await crearCurso(organizacion.id, values)
    navigate('/cursos', { replace: true, state: { message: 'Curso creado correctamente.' } })
  }

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div><p className="text-sm font-semibold text-primary">Cursos</p><h2 className="mt-1 text-3xl font-bold tracking-tight">Nuevo curso</h2><p className="mt-2 text-text-secondary">Ingresa los datos para registrar un curso en el establecimiento.</p></div>
      <CursoForm onSubmit={handleSubmit} onCancel={() => navigate('/cursos')} submitLabel="Guardar curso" />
    </div>
  )
}
